document.addEventListener('DOMContentLoaded', () => {
    const $poNumber = $('#PoNumber');
    $poNumber.trigger('focus');
    const $bolSearchButton = $('#bolSearchButton');
    $bolSearchButton.off('click').on('click', () => $('#bolForm').trigger('submit'));
    $poNumber.on('click', function () {
        $(this).trigger('select');
    });
    if ($poNumber.length) {
        $poNumber.trigger('select');
        $poNumber.on('keyup', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                $('#bolForm').trigger('submit');
            }
        });
    }
});
